<template>
    <div class="section">
        <transactions-client-table :user="user"></transactions-client-table>
        <delete-client-transaction-modal v-if="isDeleteModal"></delete-client-transaction-modal>
    </div>
</template>

<script>
    import TransactionsClientTable from "./TransactionsClientTable";
    import DeleteClientTransactionModal from "./DeleteClientTransactionModal";
    export default {
        props: ['user'],
        components: {
            DeleteClientTransactionModal,
            TransactionsClientTable,
        },
        computed: {
            isAdmin() {
                if (this.$store.getters.getUserRole === 'Admin') {
                    return true
                }
            },
            isDeleteModal() {
                return this.$store.getters.getTransactionDeleteModalStatus
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Balance-Statement/TransactionsClient.vue